import i18n from '../../i18n';

export default {
  uploadAFile: 'انتخاب فایل',
  dragAndDrop: 'فایل را در اینجا رها کنید تا بارگذاری شود',
  failedToCompressImage: 'امکان فشرده سازی عکس وجود ندارد',
  validFormats: 'فرمت‌های مجاز: ',
  fileName(name: string) {
    return i18n.t('fileName', { ns: 'survey', name });
  },
  fileSize(size: string) {
    return i18n.t('fileSize', { ns: 'survey', size });
  },
  maxSizeUpload(size: string) {
    return i18n.t('maxSizeUpload', { ns: 'survey', size });
  },
};

export const definedTypes = {
  audio: 'فایل صوتی',
  video: 'فیلم',
  image: 'عکس',
  document: 'اسناد',
  compressed: 'فایل فشرده',
};
